import { Input } from 'components/NumericalInput'
import styled from 'styled-components/macro'

export const StyledInput = styled(Input)`
  color: ${({ theme }) => theme.textPrimary};
  width: 100%;
  position: relative;
  font-weight: 500;
  outline: none;
  border: none;
  flex: 1 1 auto;
  background-color: ${({ theme }) => theme.deprecated_bg1};
  font-size: 16px;
  padding: 12px;
  border-radius: 12px;
  border: 1px solid ${({ theme }) => theme.backgroundOutline};
`

export const DateTimeInput = styled.input`
  color: ${({ theme }) => theme.textPrimary};
  width: 100%;
  position: relative;
  font-weight: 500;
  outline: none;
  border: none;
  flex: 1 1 auto;
  background-color: ${({ theme }) => theme.deprecated_bg1};
  font-size: 16px;
  padding: 12px;
  border-radius: 12px;
  border: 1px solid ${({ theme }) => theme.backgroundOutline};
  cursor: pointer;

  &:focus {
    border: 1px solid ${({ theme }) => theme.accentAction};
  }

  &::-webkit-calendar-picker-indicator {
    filter: ${({ theme }) => (theme.darkMode ? 'invert(1)' : 'none')};
    cursor: pointer;
  }
`

export const DateTimeContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 4px;
`

export const DateTimeLabel = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;

  span:last-child {
    font-size: 11px;
    color: ${({ theme }) => theme.textSecondary};
    font-style: italic;
    padding-left: 6px;
  }
`

export const TimestampDisplay = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.textSecondary};
  margin-top: 4px;
  padding: 4px 8px;
  background-color: ${({ theme }) => theme.backgroundModule};
  border-radius: 8px;
  width: fit-content;
`
